export const INSTALLLMENTS = [
  { value: 1, label: "A vista" },
  { value: 2, label: "2 Parcelas" },
  { value: 3, label: "3 Parcelas" },
  { value: 4, label: "4 Parcelas" },
  { value: 5, label: "5 Parcelas" },
  { value: 6, label: "6 Parcelas" },
  { value: 7, label: "7 Parcelas" },
  { value: 8, label: "8 Parcelas" },
  { value: 9, label: "9 Parcelas" },
  { value: 10, label: "10 Parcelas" },
  { value: 11, label: "11 Parcelas" },
  { value: 12, label: "12 Parcelas" },
  { value: 13, label: "13 Parcelas" },
  { value: 14, label: "14 Parcelas" },
  { value: 15, label: "15 Parcelas" },
  { value: 16, label: "16 Parcelas" },
  { value: 17, label: "17 Parcelas" },
  { value: 18, label: "18 Parcelas" },
  { value: 19, label: "19 Parcelas" },
  { value: 20, label: "20 Parcelas" },
  { value: 21, label: "21 Parcelas" },
  { value: 22, label: "22 Parcelas" },
  { value: 23, label: "23 Parcelas" },
  { value: 24, label: "24 Parcelas" }
];

export const PAYMENT_METHODS = [
  { value: "credit_card", label: "Cartão de Crédito" },
  { value: "boleto", label: "Boleto" }
];
